import pickup from './pickup'

export default [
  ...pickup,
]
